import * as React from "react";
import { useMemo, useCallback } from "react";
import { Formik } from "formik";
import { Modal } from "components/bootstrap";
import { useModalContext } from "common/contexts";
import { useCreateAsset, useUpdateAsset } from "security-app/hooks/useAssetsAPI";
import { validations } from "./utils";
import UserFormFields from "./UserFormFields";
import UserFormButtons from "./UserFormButtons";
const INIT_USER = {
  name: "",
  category: [],
  priority: 1,
  // Low priority by default
  details: {
    type: "user",
    usernames: [],
    user_ids: [],
    email_addresses: [],
    first_name: "",
    last_name: ""
  }
};
function UserForm({ asset = INIT_USER, show, onClose }) {
  const isEditing = useMemo(() => !!(asset == null ? void 0 : asset.id), [asset == null ? void 0 : asset.id]);
  const { entity, setEntity } = useModalContext();
  const { createAsset } = useCreateAsset();
  const { updateAsset } = useUpdateAsset();
  const onSubmit = useCallback(
    async (values) => {
      const newAsset = { ...asset, ...values };
      if (isEditing) {
        await updateAsset({ assetId: newAsset.id, asset: newAsset });
        setEntity({ ...entity, asset: newAsset });
      } else {
        await createAsset({ asset: newAsset });
      }
      onClose();
    },
    [asset, isEditing, onClose, updateAsset, setEntity, entity, createAsset]
  );
  return /* @__PURE__ */ React.createElement(Formik, { onSubmit, initialValues: asset, validate: validations }, /* @__PURE__ */ React.createElement(Modal, { show, onHide: onClose }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, isEditing ? "Edit User Asset" : "New User Asset")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(UserFormFields, null)), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(UserFormButtons, { isEditing, onCancel: onClose }))));
}
export default UserForm;
